{
  "nav": {
    "home": "Start",
    "events": "Events",
    "music": "Musik",
    "sets": "Sets",
    "drops": "Drops",
    "about": "Über",
    "press": "Press Kit",
    "booking": "Booking",
    "openMenu": "Menü öffnen",
    "closeMenu": "Menü schließen",
    "skipToContent": "Zum Inhalt springen",
    "venues": "Venues",
    "rider": "DJ Rider",
    "livesets": "Sets",
    "links": "Links",
    "mobile": "Hauptnavigation"
  },
  "lang": {
    "label": "Sprache",
    "en": "EN",
    "de": "DE"
  },
  "hero": {
    "ctaEvents": "Upcoming Events",
    "ctaBooking": "Ajay buchen",
    "scroll": "Scrollen"
  },
  "events": {
    "eyebrow": "Live",
    "title": "Events",
    "all": "Alle Events",
    "empty": "Gerade keine Termine. Folge auf Instagram für das nächste Datum.",
    "past": "Vergangene Events",
    "minAge": "ab {{age}}",
    "badge": {
      "live": "Jetzt live",
      "guestlistOpen": "Gästeliste offen",
      "guestlistFull": "Warteliste",
      "tickets": "Tickets",
      "past": "Vorbei"
    },
    "detail": {
      "back": "Alle Events",
      "date": "Datum",
      "time": "Uhrzeit",
      "doors": "{{start}} – {{end}}",
      "venue": "Location",
      "lineup": "Line-up",
      "age": "Alter",
      "dresscode": "Dresscode",
      "googleMaps": "Google Maps",
      "appleMaps": "Apple Karten",
      "joinGuestlist": "Auf die Gästeliste",
      "joinWaitlist": "Auf die Warteliste",
      "guestlistClosed": "Gästeliste geschlossen",
      "externalTickets": "Tickets holen",
      "addToCalendar": "Zum Kalender",
      "share": "Teilen",
      "copied": "Link kopiert",
      "calendarApple": "Apple / Outlook (.ics)",
      "calendarGoogle": "Google Kalender",
      "startsIn": "Beginnt in",
      "liveNow": "Läuft gerade",
      "archived": "Dieses Event hat bereits stattgefunden.",
      "days": "Tage",
      "hours": "Std",
      "minutes": "Min",
      "seconds": "Sek",
      "about": "Über das Event",
      "waitlistInfo": "Die Gästeliste ist voll. Du kannst dich auf die Warteliste setzen und wirst benachrichtigt, wenn ein Platz frei wird.",
      "spotsLeft": "Noch {{count}} Plätze",
      "noLineup": "TBA"
    },
    "guestlist": "Gästeliste"
  },
  "tiles": {
    "eyebrow": "Entdecken",
    "title": "Alles von AJAY"
  },
  "music": {
    "eyebrow": "Hören",
    "title": "Musik",
    "spotifyTodo": "Der Spotify-Artist-Player erscheint hier, sobald die Spotify-URL eingetragen ist.",
    "consent": "Wird über Spotify abgespielt. Daten gehen erst nach dem Tippen an Spotify.",
    "soundcloud": "SoundCloud",
    "playlists": "Playlists"
  },
  "sets": {
    "eyebrow": "Ansehen",
    "title": "Sets & Videos",
    "play": "Video abspielen",
    "consent": "Wird über YouTube (youtube-nocookie.com) abgespielt. Daten gehen erst nach dem Tippen an YouTube.",
    "watchLive": "Live auf Twitch ansehen",
    "latest": "Neueste Uploads"
  },
  "drops": {
    "eyebrow": "Für DJs",
    "title": "Drops",
    "getIt": "Holen"
  },
  "about": {
    "eyebrow": "Ein bisschen",
    "title": "Über mich",
    "genres": "Genres",
    "photosTodo": "TODO: Fotos"
  },
  "booking": {
    "eyebrow": "Booking",
    "title": "Ajay buchen",
    "intro": "Club, Festival, privat oder Firmenevent – erzähl mir von deinem Event.",
    "orMail": "Oder direkt an",
    "fields": {
      "name": "Name",
      "company": "Firma / Veranstalter",
      "email": "E-Mail",
      "phone": "Telefon",
      "eventType": "Art des Events",
      "date": "Datum",
      "location": "Stadt / Location",
      "setLength": "Set-Länge",
      "expectedGuests": "Erwartete Gäste",
      "budget": "Budget",
      "message": "Nachricht",
      "privacy": "Ich habe die <1>Datenschutzerklärung</1> gelesen und bin einverstanden, dass meine Daten zur Bearbeitung der Anfrage verarbeitet werden.",
      "website": "Dieses Feld leer lassen"
    },
    "optional": "optional",
    "select": "Bitte wählen",
    "eventTypes": {
      "club": "Club",
      "festival": "Festival",
      "private": "Privat",
      "corporate": "Firmenevent",
      "wedding": "Hochzeit",
      "other": "Sonstiges"
    },
    "budgets": {
      "lt500": "Unter 500 €",
      "500to1000": "500 – 1.000 €",
      "1000to2000": "1.000 – 2.000 €",
      "gt2000": "Über 2.000 €",
      "tbd": "Nach Absprache"
    },
    "submit": "Anfrage senden",
    "successTitle": "Anfrage gesendet!",
    "successText": "Danke, {{name}}. Du bekommst eine Bestätigung an {{email}} – ich melde mich bald.",
    "another": "Weitere Anfrage senden"
  },
  "support": {
    "text": "Dir gefallen die Sets und Edits?",
    "button": "Support me"
  },
  "footer": {
    "imprint": "Impressum",
    "privacy": "Datenschutz",
    "terms": "AGB",
    "rights": "Alle Rechte vorbehalten."
  },
  "press": {
    "eyebrow": "Presse",
    "title": "Press Kit 2026",
    "short": "Kurz-Bio",
    "long": "Lange Bio",
    "download": "Press Kit herunterladen (PDF)",
    "pdfTodo": "TODO: Das Press-Kit-PDF wird im Admin hochgeladen.",
    "photos": "Pressefotos",
    "onRequest": "Hochauflösende Fotos und Videos auf Anfrage:"
  },
  "legal": {
    "imprint": "Impressum",
    "privacy": "Datenschutzerklärung",
    "terms": "AGB"
  },
  "admin": {
    "nav": {
      "dashboard": "Start",
      "events": "Events",
      "inbox": "Anfragen",
      "design": "Design",
      "links": "Links",
      "content": "Texte",
      "viewSite": "Website ansehen"
    },
    "auth": {
      "title": "Anmelden",
      "email": "E-Mail",
      "password": "Passwort",
      "signIn": "Anmelden",
      "google": "Mit Google fortfahren",
      "forgot": "Passwort vergessen?",
      "resetSent": "E-Mail zum Zurücksetzen gesendet.",
      "enterEmailFirst": "Bitte zuerst die E-Mail eingeben.",
      "wrongCredentials": "E-Mail oder Passwort falsch.",
      "tooMany": "Zu viele Versuche. Bitte später nochmal.",
      "failed": "Anmeldung fehlgeschlagen. Bitte nochmal versuchen.",
      "signOut": "Abmelden",
      "noAccessTitle": "Kein Zugriff",
      "noAccessText": "Du bist als {{email}} angemeldet. Wenn diese E-Mail auf der Admin-Liste steht, kannst du deinen Zugang hier aktivieren.",
      "devHint": "Lokaler Test-Login:",
      "activate": "Admin-Zugang aktivieren",
      "notAllowed": "Dieses Konto steht nicht auf der Admin-Liste. Bitte die E-Mail in ADMIN_EMAILS eintragen lassen und die Functions neu deployen."
    },
    "common": {
      "all": "Alle",
      "close": "Schließen",
      "delete": "Löschen",
      "deleted": "Gelöscht.",
      "discard": "Verwerfen",
      "dragToSort": "Ziehen zum Sortieren",
      "edit": "Bearbeiten",
      "english": "Englisch (Pflicht)",
      "germanOptional": "Deutsch (optional – sonst wird Englisch angezeigt)",
      "error": "Etwas ist schiefgelaufen. Bitte nochmal versuchen.",
      "language": "Sprache",
      "optional": "(optional)",
      "save": "Speichern",
      "saved": "Gespeichert.",
      "saving": "Speichert…",
      "unsaved": "Ungespeicherte Änderungen",
      "view": "Ansehen"
    },
    "dashboard": {
      "title": "Hi Ajay 👋",
      "upcoming": "Kommend",
      "guests": "Gäste",
      "newBookings": "Neue Anfragen",
      "nextEvents": "Nächste Events",
      "noEvents": "Keine kommenden Events.",
      "latestBookings": "Neueste Booking-Anfragen"
    },
    "events": {
      "new": "Neues Event",
      "untitled": "Neues Event",
      "upcoming": "Kommend",
      "past": "Vergangen",
      "none": "Hier gibt es noch keine Events.",
      "notFound": "Event nicht gefunden.",
      "draft": "Entwurf",
      "published": "Veröffentlicht",
      "publishHint": "Nur veröffentlichte Events sind auf der Website sichtbar.",
      "guestlist": "Gästeliste",
      "basics": "Grunddaten",
      "title": "Titel",
      "slug": "Link",
      "starts": "Beginn",
      "ends": "Ende",
      "viennaTime": "(Wiener Zeit)",
      "venue": "Location",
      "venueName": "Name der Location",
      "address": "Adresse",
      "mapsUrl": "Google-Maps-Link",
      "details": "Details",
      "description": "Beschreibung",
      "lineup": "Line-up",
      "lineupHint": "(ein Name pro Zeile)",
      "minAge": "Mindestalter",
      "dresscode": "Dresscode (optional)",
      "flyer": "Flyer",
      "flyerUpload": "Flyer-Bild",
      "flyerHint": "(wird automatisch auf 4:5 zugeschnitten)",
      "guestlistEnabled": "Gästeliste aktiv",
      "capacity": "Kapazität (Personen)",
      "maxPlusOnes": "Max. Begleitpersonen",
      "deadline": "Anmeldeschluss",
      "countInfo": "Aktuell auf der Liste: {{count}} Personen (inkl. Begleitung).",
      "tickets": "Tickets",
      "externalUrl": "Externer Ticket-Link",
      "ticketsDeferred": "Eigener Ticketverkauf über PayPal kommt als späteres Feature.",
      "delete": "Event löschen",
      "confirmDelete": "„{{title}}“ inklusive Gästeliste wirklich löschen? Das kann nicht rückgängig gemacht werden.",
      "errors": {
        "title": "Bitte einen Titel eingeben.",
        "slug": "Link: nur Kleinbuchstaben, Zahlen und Bindestriche.",
        "slugTaken": "Dieser Link wird schon von einem anderen Event verwendet.",
        "dates": "Das Ende muss nach dem Beginn liegen.",
        "minAge": "Mindestalter muss eine Zahl sein.",
        "guestlist": "Gästeliste: Kapazität mindestens 1, Begleitpersonen 0–10.",
        "url": "Bitte Links mit https:// eingeben.",
        "venue": "Veröffentlichte Events brauchen eine Location."
      },
      "noSignupHint": "Ohne Gästelisten-Link gibt es auf der Event-Seite keinen Anmelde-Button.",
      "guestlistLink": "Gästelisten-Link",
      "guestlistLinkHint": "(z. B. getguestlist.io – ersetzt die eigene Gästeliste)",
      "flyerBundled": "Noch kein Flyer. Flyer kommen mit der Website und heißen wie der Event-Tag: {{file}}"
    },
    "guestlist": {
      "confirmed": "Bestätigt",
      "waitlist": "Warteliste",
      "checkedIn": "Eingecheckt",
      "search": "Name oder E-Mail suchen",
      "filter": "Filter",
      "empty": "Noch niemand auf der Liste.",
      "noMatch": "Keine Treffer.",
      "checkIn": "Einchecken",
      "in": "Drin",
      "promote": "{{name}} von der Warteliste auf die Gästeliste setzen",
      "promoted": "{{name}} steht jetzt auf der Gästeliste.",
      "confirmOverCapacity": "Damit wird die Kapazität überschritten. Trotzdem auf die Gästeliste setzen?",
      "confirmDelete": "{{name}} von der Liste entfernen?",
      "print": "Drucken",
      "sendList": "Liste mailen",
      "listSent": "Gästeliste per E-Mail verschickt ({{count}} Einträge).",
      "name": "Name",
      "statusCol": "Status",
      "phone": "Telefon"
    },
    "inbox": {
      "empty": "Noch keine Booking-Anfragen.",
      "reply": "Per E-Mail antworten",
      "statusLabel": "Status",
      "notes": "Interne Notizen",
      "confirmDelete": "Anfrage von {{name}} löschen?",
      "status": {
        "new": "Neu",
        "inProgress": "In Bearbeitung",
        "confirmed": "Bestätigt",
        "declined": "Abgelehnt"
      }
    },
    "design": {
      "subtitle": "Änderungen erscheinen zuerst in der Vorschau und gehen mit „Veröffentlichen“ live.",
      "preview": "Vorschau",
      "livePreview": "Live-Vorschau",
      "publish": "Veröffentlichen",
      "published": "Veröffentlicht – die Website ist aktualisiert.",
      "brand": "Marke",
      "accent": "Akzentfarbe",
      "presets": "Farbvorschläge",
      "invalidColor": "Bitte eine gültige Farbe wählen.",
      "logo": "Logo",
      "logoHint": "(SVG oder PNG, transparent)",
      "marquee": "Laufband-Text",
      "hero": "Hero",
      "headline": "Überschrift",
      "subline": "Unterzeile",
      "quote": "Claim / Zitat",
      "heroMedia": "Hero-Medium",
      "none": "Keins",
      "image": "Bild",
      "video": "Video",
      "heroImage": "Porträt (freigestellt)",
      "heroVideo": "Hero-Video",
      "videoHint": "(MP4, möglichst unter 3 MB)",
      "poster": "Vorschaubild",
      "posterHint": "(wird gezeigt, bis das Video lädt)",
      "background": "Hintergrund",
      "color": "Farbe",
      "gradient": "Verlauf",
      "angle": "Winkel",
      "addColor": "Farbe hinzufügen",
      "removeColor": "Farbe entfernen",
      "overlay": "Abdunklung",
      "overlayHint": "Mindestens 40 % Abdunklung halten Text auf jedem Bild lesbar.",
      "sections": "Sektionen",
      "sectionsHint": "Ziehen zum Sortieren, Auge zum Ein- und Ausblenden. Der Hero steht immer oben.",
      "hidden": "ausgeblendet",
      "sectionNames": {
        "marquee": "Laufband",
        "events": "Upcoming Events",
        "tiles": "Kacheln",
        "music": "Musik",
        "sets": "Sets & Videos",
        "drops": "Drops",
        "about": "Über",
        "booking": "Booking",
        "support": "Support",
        "instagram": "Instagram",
        "info": "Infos",
        "stats": "Reichweite",
        "venues": "Venues",
        "rider": "DJ Rider",
        "livesets": "Live DJ Sets",
        "lection": "LECTION",
        "contact": "Kontakt",
        "artists": "Artist Support",
        "produced": "Produced by Ajay",
        "links": "Links (Linktree)"
      },
      "style": "Look",
      "styles": {
        "sand": "Sand (Press Kit)",
        "dark": "Dunkel (Club)"
      },
      "styleHint": "„Sand“ nutzt die Press-Kit-Farben; die Hintergrund-Einstellungen unten gelten dann nicht.",
      "defaultHint": "Leer lassen = Version aus dem Press Kit.",
      "heroImageHint": "(PNG mit transparentem oder sandfarbenem Hintergrund)",
      "line1": "Zeile 1 unter dem Logo",
      "line2": "Zeile 2 unter dem Logo"
    },
    "links": {
      "add": "Link hinzufügen",
      "edit": "Link bearbeiten",
      "title": "Titel",
      "subtitle": "Untertitel",
      "subtitleHint": "Ziehen zum Sortieren, Auge zum Ausblenden. Änderungen sind sofort live.",
      "category": "Kategorie",
      "icon": "Icon",
      "cover": "Cover-Bild",
      "visible": "Auf der Website sichtbar",
      "empty": "Keine Links in dieser Kategorie.",
      "invalid": "Bitte Titel und einen Link mit https:// eingeben.",
      "confirmDelete": "„{{title}}“ löschen?",
      "hide": "{{title}} ausblenden",
      "show": "{{title}} einblenden",
      "categories": {
        "social": "Social",
        "streaming": "Streaming",
        "sets": "Sets",
        "drops": "Drops"
      }
    },
    "content": {
      "tabs": {
        "general": "Allgemein",
        "about": "Bio",
        "press": "Press Kit",
        "tiles": "Kacheln",
        "legal": "Rechtliches"
      },
      "artistName": "Künstlername",
      "bookingEmail": "Booking-E-Mail",
      "spotify": "Spotify-Artist-Link",
      "spotifyHint": "(aktiviert den Spotify-Player)",
      "lection": "LECTION-Link",
      "support": "PayPal.me-Link",
      "genres": "Genres",
      "genresHint": "(mit Komma getrennt)",
      "invalidEmail": "Bitte eine gültige Booking-E-Mail eingeben.",
      "bioShort": "Kurz-Bio",
      "bioLong": "Lange Bio (Press Kit)",
      "aboutPhotos": "Über-mich-Fotos (max. 4)",
      "pressPdf": "Press-Kit-PDF",
      "pressPdfHint": "(max. 20 MB)",
      "pressPhotos": "Pressefotos",
      "tilesHint": "Kachel antippen zum Bearbeiten, ziehen zum Sortieren.",
      "tileHref": "Ziel",
      "tileHrefHint": "(z. B. /#music, /press oder https://…)",
      "tileImage": "Bild",
      "legalHint": "Rechtstexte müssen von Ajay bzw. einer Anwältin/einem Anwalt geprüft werden. Ein Impressum ist in Österreich Pflicht.",
      "linkPrompt": "Link (leer zum Entfernen):",
      "factsTitle": "Infos",
      "factsEn": "Fakten (Englisch)",
      "factsDe": "Fakten (Deutsch, optional)",
      "factsDeHint": "(gleiche Zeile wie auf Englisch)",
      "onePerLine": "(eine pro Zeile)",
      "infoPhoto": "Foto für Infos",
      "statsTitle": "Reichweite",
      "statPlatform": "Plattform",
      "statLabel": "Beschriftung",
      "statValue": "Zahl",
      "statAdd": "Zeile hinzufügen",
      "venuesTitle": "Gespielt in (Venues)",
      "venuesPhoto": "Foto für Venues",
      "riderTitle": "DJ Rider",
      "riderGear": "Equipment",
      "riderNote": "Hinweis für Veranstalter",
      "liveSets": "Live-Set-Playlist (YouTube)",
      "contactPhoto": "Foto für Kontakt",
      "riderPhoto": "Foto vom Setup",
      "statUrl": "Link zum Profil",
      "artistsTitle": "Artist Support",
      "artistsList": "Artists",
      "artistsPhoto": "Foto für Artist Support",
      "producedTitle": "Produced by Ajay",
      "remixes": "Remixes (links)",
      "tracks": "Produktionen (rechts)",
      "producedPhoto": "Foto (freigestellt)",
      "contactUrl": "Link für „Click here“ (Kontakt)",
      "contactUrlHint": "(leer = Booking-Formular)",
      "guestlistUrl": "Standard-Gästelisten-Link",
      "guestlistUrlHint": "(für Events ohne eigenen Link)",
      "pressKitUrl": "Press-Kit-Link (pCloud)"
    },
    "media": {
      "upload": "Hochladen",
      "replace": "Ersetzen",
      "remove": "Entfernen",
      "failed": "Upload fehlgeschlagen.",
      "tooLarge": "Datei zu groß (max. {{mb}} MB).",
      "videoHeavy": "Hinweis: Videos über 3 MB machen die Seite auf dem Handy langsam.",
      "addPhotos": "Fotos hinzufügen",
      "uploading": "Noch {{count}}…",
      "orLink": "… oder Bild-Link einfügen",
      "disabled": "Bilder-Upload ist vorerst ausgeschaltet (braucht den Firebase-Blaze-Tarif). Bilder kommen mit der Website – schick sie an Claude.",
      "removeOld": "Alten Upload entfernen"
    },
    "feeds": {
      "title": "Automatische Inhalte",
      "intro": "Neue YouTube-Uploads und Instagram-Posts erscheinen automatisch auf der Website (stündlich geprüft).",
      "syncNow": "Jetzt aktualisieren",
      "youtubeHint": "Neueste Uploads der YouTube-Kanäle aus deinen Social-Links.",
      "instagramHint": "Braucht ein Instagram-Professional-Konto (Business/Creator) und einen Zugangsschlüssel aus dem Meta-Developer-Dashboard (Instagram API with Instagram Login). Der Schlüssel wird sicher gespeichert und automatisch verlängert.",
      "videos": "Videos",
      "posts": "Posts",
      "lastSync": "Zuletzt aktualisiert {{date}} · {{count}} {{label}}",
      "never": "Noch nicht synchronisiert.",
      "connected": "Verbunden",
      "notConnected": "Nicht verbunden",
      "token": "Zugangsschlüssel (Access Token)",
      "replaceToken": "Zugangsschlüssel ersetzen",
      "connect": "Verbinden",
      "tokenInvalid": "Das sieht nicht nach einem gültigen Schlüssel aus.",
      "tokenSaved": "Schlüssel gespeichert.",
      "synced": "Aktualisiert: {{videos}} Videos, {{posts}} Posts.",
      "disconnect": "Instagram trennen",
      "confirmDisconnect": "Instagram-Schlüssel entfernen? Bereits angezeigte Posts bleiben bis zur nächsten Aktualisierung.",
      "disconnected": "Instagram getrennt."
    },
    "import": {
      "title": "Website einrichten",
      "text": "Die Datenbank ist noch leer. Importiere die Startinhalte: alle Links aus dem Linktree, Texte, Design und Reihenfolge der Sektionen. Alles ist danach bearbeitbar; Bestehendes wird nicht überschrieben.",
      "button": "Startinhalte importieren",
      "done": "Startinhalte importiert."
    },
    "scan": {
      "open": "Scanner",
      "counter": "{{in}} / {{total}} Personen drin",
      "manual": "Gästeliste (manuell einchecken)",
      "camera": "Kamera",
      "hint": "QR-Code des Gasts in den Rahmen halten",
      "tapToContinue": "Tippen für den nächsten Scan",
      "alreadyAt": "Schon eingecheckt um {{time}}",
      "needsHttps": "Die Kamera funktioniert nur über HTTPS (Live-Seite) oder auf localhost.",
      "permission": "Kamerazugriff wurde verweigert. In den Browser-Einstellungen erlauben und neu laden.",
      "noCamera": "Keine Kamera gefunden.",
      "result": {
        "ok": "Willkommen!",
        "already": "Schon drin",
        "waitlist": "Nur Warteliste",
        "wrongEvent": "Anderes Event",
        "invalid": "Ungültiger Code"
      }
    }
  },
  "notFound": {
    "title": "Beat verloren.",
    "text": "Diese Seite gibt es nicht.",
    "back": "Zur Startseite"
  },
  "common": {
    "loading": "Lädt…",
    "back": "Zurück",
    "external": "öffnet in neuem Tab",
    "close": "Schließen"
  },
  "errors": {
    "required": "Pflichtfeld",
    "email": "Bitte eine gültige E-Mail eingeben",
    "phone": "Bitte eine gültige Telefonnummer eingeben",
    "date": "Bitte ein Datum wählen",
    "number": "Bitte eine Zahl eingeben",
    "privacy": "Bitte die Datenschutzerklärung akzeptieren"
  },
  "pill": {
    "next": "Nächstes Event",
    "live": "Jetzt live",
    "startsIn": "Beginnt in",
    "d": "T",
    "h": "h",
    "m": "m"
  },
  "forms": {
    "sending": "Wird gesendet…",
    "errors": {
      "duplicate": "Du stehst mit dieser E-Mail-Adresse bereits auf der Liste.",
      "closed": "Die Gästeliste für dieses Event ist geschlossen.",
      "past": "Dieses Event hat bereits stattgefunden.",
      "notFound": "Dieses Event ist nicht mehr verfügbar.",
      "tooManyPlusOnes": "Zu viele Begleitpersonen für dieses Event.",
      "rateLimited": "Zu viele Versuche. Bitte versuche es in ein paar Minuten nochmal.",
      "invalid": "Bitte prüfe deine Eingaben.",
      "network": "Keine Verbindung. Bitte prüfe dein Internet und versuche es nochmal.",
      "unknown": "Etwas ist schiefgelaufen. Bitte versuche es nochmal."
    }
  },
  "guestlist": {
    "title": "Auf die Gästeliste",
    "waitlistTitle": "Auf die Warteliste",
    "firstName": "Vorname",
    "lastName": "Nachname",
    "email": "E-Mail",
    "phone": "Telefon",
    "plusOnes": "Begleitpersonen",
    "plusOnesHint": "Max. {{max}}",
    "decrease": "Weniger Begleitpersonen",
    "increase": "Mehr Begleitpersonen",
    "privacy": "Ich habe die <1>Datenschutzerklärung</1> gelesen und bin einverstanden, dass meine Daten für die Gästeliste verarbeitet werden.",
    "newsletter": "Haltet mich über kommende Events auf dem Laufenden (Newsletter, optional).",
    "submit": "Ich bin dabei",
    "submitWaitlist": "Auf die Warteliste setzen",
    "confirmedTitle": "Du stehst auf der Liste!",
    "confirmedText": "Wir haben dir eine Bestätigung an {{email}} geschickt. Bring einen Ausweis mit – bis dann.",
    "waitlistDoneTitle": "Du stehst auf der Warteliste",
    "waitlistDoneText": "Die Gästeliste ist gerade voll. Wir haben dir eine Bestätigung an {{email}} geschickt und melden uns, falls ein Platz frei wird.",
    "done": "Fertig"
  },
  "instagram": {
    "eyebrow": "Folgen",
    "title": "Instagram",
    "follow": "Clips, Sets und Behind the Scenes – folge auf Instagram.",
    "post": "Beitrag auf Instagram öffnen"
  },
  "pass": {
    "title": "Gästepass",
    "qrLabel": "QR-Code des Gästepasses",
    "showAtDoor": "Zeig diesen QR-Code am Einlass – er gilt für dich und deine Begleitung.",
    "brightness": "Tipp: Bildschirmhelligkeit hochdrehen.",
    "open": "Gästepass öffnen",
    "guests": "{{count}} Person",
    "guests_other": "{{count}} Personen",
    "valid": "Gültig",
    "checkedIn": "Eingecheckt",
    "waitlist": "Warteliste",
    "waitlistText": "Du stehst auf der Warteliste. Wird ein Platz frei, bekommst du eine E-Mail mit deinem QR-Code.",
    "past": "Dieses Event hat bereits stattgefunden.",
    "eventDetails": "Zum Event",
    "notFoundTitle": "Pass nicht gefunden.",
    "notFoundText": "Der Link ist unvollständig oder nicht mehr gültig. Bitte nutze den Link aus deiner Bestätigungs-Mail."
  },
  "errorBoundary": {
    "title": "Da hat etwas nicht geladen.",
    "text": "Vermutlich wurde die Website gerade aktualisiert. Neu laden behebt das.",
    "reload": "Neu laden"
  },
  "info": {
    "title": "Die wichtigsten Infos"
  },
  "stats": {
    "title": "Reichweite"
  },
  "venues": {
    "title": "Gespielt in",
    "austria": "Österreich",
    "international": "International",
    "more": "Und viele mehr …"
  },
  "rider": {
    "title": "DJ Rider"
  },
  "livesets": {
    "title": "Live DJ Sets",
    "qr": "QR-Code zur Live-Set-Playlist auf YouTube",
    "intro": "Komplette Live-Sets aus den Clubs – alle in einer Playlist.",
    "scan": "Mit dem Handy scannen oder die Playlist direkt öffnen.",
    "watch": "Auf YouTube ansehen"
  },
  "lection": {
    "more": "Mehr erfahren",
    "tagline": "No genre, just vibes – hosted by Ajay"
  },
  "contact": {
    "title": "Kontakt",
    "cta": "Hier klicken"
  },
  "artists": {
    "title": "Artist Support",
    "more": "Und viele mehr!"
  },
  "produced": {
    "title": "Produced by Ajay",
    "more": "Und viele mehr …"
  },
  "links": {
    "title": "Links",
    "groups": {
      "social": "Socials",
      "streaming": "Streaming",
      "sets": "DJ-Sets",
      "drops": "Drops & Tools"
    }
  }
}
